import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function MenuFacturacion() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    // Función para verificar si el usuario tiene un permiso específico
    const checkPermission = (permissionSlug) => {
        if (localStorage.getItem('userdata')) {
            const userData = JSON.parse(localStorage.getItem('userdata'));
            return userData.up && userData.up.includes(permissionSlug);
        }
        return false;
    };

    useEffect(()=>{

        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // Validación de permisos híbrida (nuevo + legacy)
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => 
                permission.slug === 'ver_listado_presupuestos' || 
                permission.slug === 'ver_listado_facturas' ||
                permission.slug === 'ver_listado_documentos_soporte'
            );
        } else if (userdata.up) {
            tienePermiso = userdata.up.includes('ver_listado_presupuestos') || 
                          userdata.up.includes('ver_listado_facturas') ||
                          userdata.up.includes('ver_listado_documentos_soporte');
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
                setLoggedIn(true);
            });
    },[]);

    // Protección de ruta - Patrón estándar del proyecto
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item">Contabilidad</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Contabilidad</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">
                        <div className="row">
                            {/* Presupuesto - Solo mostrar si tiene permiso */}
                            {checkPermission('ver_listado_presupuestos') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Presupuesto</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-calculator"></i>
                                        </div>
                                        <Link to="/listado-presupuestos" className="small-box-footer">
                                            Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {/* Facturación - Solo mostrar si tiene permiso */}
                            {checkPermission('ver_listado_facturas') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Facturación</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-file-invoice"></i>
                                        </div>
                                        <Link to="/listado-facturas" className="small-box-footer">
                                            Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {/* Documento Soporte - Solo mostrar si tiene permiso */}
                            {checkPermission('ver_listado_documentos_soporte') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Documento Soporte</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-file-alt"></i>
                                        </div>
                                        <Link to="/listado-documentos-soporte" className="small-box-footer">
                                            Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {/* Egresos - Solo mostrar si tiene permiso */}
                            {checkPermission('ver_listado_documentos_soporte') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Egresos</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-money-bill-wave"></i>
                                        </div>
                                        <Link to="/listado-egresos" className="small-box-footer">
                                            Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
        
    );
}
export default MenuFacturacion;